import { Icon, Space } from '@sravni/react-design-system';

import type { Badge, ModifyBadgesResult } from 'commonTypes/api/scenarios/BaseTypes';

// TODO: https://sravni-corp.atlassian.net/browse/CF-5617
export const modifyBadges = (badges: Badge[]): ModifyBadgesResult => {
  const result =
    badges?.reduce<ModifyBadgesResult>((acc, badge) => {
      if (['creditCard', 'credit', 'preApprovalOffer'].includes(badge.code)) {
        return acc;
      }

      if (badge.icon) {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const DetailIcon = require('@sravni/react-icons')[badge.icon || 'Fire'];
        acc.push({
          color: badge.color || 'dark',
          variant: badge.type,
          text: (
            <Space
              size={4}
              align="center"
            >
              {badge.title}
              <Icon
                size={16}
                icon={<DetailIcon />}
              />
            </Space>
          ),
        });

        return acc;
      }

      acc.push({ variant: badge.type, text: badge.title, color: badge.color || 'dark' });

      return acc;
    }, []) || [];

  return result;
};
